var map = {
	"./additionalInfoIcon.svg": 507,
	"./arrowLeftIcon.svg": 508,
	"./arrowMediumTop.svg": 509,
	"./arrowRightIcon.svg": 510,
	"./arrowRightIconSharp.svg": 511,
	"./arrowRightSmallIcon.svg": 512,
	"./arrowScalableIcon.svg": 513,
	"./arrowSelect2.svg": 514,
	"./arrowSelectIcon.svg": 515,
	"./benefit1.svg": 516,
	"./benefit2.svg": 517,
	"./benefit3.svg": 518,
	"./cardsIcon.svg": 519,
	"./copyIcon copy.svg": 520,
	"./copyIcon.svg": 521,
	"./crossIcon.svg": 522,
	"./crossIcon2.svg": 523,
	"./crossIcon3.svg": 524,
	"./crossIconSmall.svg": 525,
	"./crossSmallIcon.svg": 526,
	"./defaultCategoryIcon.svg": 527,
	"./depNumberIcon.svg": 528,
	"./elfCentralIcon.svg": 529,
	"./equalitySign.svg": 530,
	"./errorIcon.svg": 418,
	"./eyeClosedIcon.svg": 531,
	"./eyeOpenIcon.svg": 532,
	"./favoritesIcon.svg": 533,
	"./favoritesLabelIcon.svg": 534,
	"./filterDivider.svg": 535,
	"./filterIcon.svg": 536,
	"./frequencyIcon.svg": 537,
	"./fsAmountIcon.svg": 538,
	"./fullScreenIcon.svg": 539,
	"./gameIcon.svg": 540,
	"./hamburgerIcon.svg": 541,
	"./infoIcon.svg": 542,
	"./infoSymbol.svg": 543,
	"./levelBackground.svg": 544,
	"./levelBackgroundNew.svg": 545,
	"./linkIcon.svg": 546,
	"./lockIcon.svg": 547,
	"./lockSharpIcon.svg": 548,
	"./maxBonusAmountIcon.svg": 549,
	"./maxWinFsIcon.svg": 550,
	"./menuIcon.svg": 551,
	"./minDepIcon.svg": 552,
	"./noTournamentIcon.svg": 553,
	"./playIcon.svg": 554,
	"./polygon.svg": 555,
	"./preloaderDotsAnimation.svg": 556,
	"./preloaderSpinnerAnimation.svg": 557,
	"./presentIcon.svg": 558,
	"./promoIcon.svg": 559,
	"./recentIcon.svg": 560,
	"./search2Icon.svg": 561,
	"./search3Icon.svg": 562,
	"./sharpTickIcon copy.svg": 563,
	"./sharpTickIcon.svg": 564,
	"./smallInfoSymbol.svg": 565,
	"./smoothArrowIcon.svg": 566,
	"./successIcon.svg": 567,
	"./supportIcon.svg": 568,
	"./tag1Icon.svg": 569,
	"./tag2Icon.svg": 570,
	"./tag3Icon.svg": 571,
	"./tag4Icon.svg": 572,
	"./tickIcon.svg": 573,
	"./unverified.svg": 574,
	"./verified.svg": 575,
	"./wagerIcon.svg": 576,
	"./wagerTimeIcon.svg": 577,
	"./warningIcon.svg": 578
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 506;